export default __webpack_public_path__ + "./image/ac8fe808ae918e82c9197123c4fa70cc.png";